import { FxTranslate } from "../../../core/translate";
import { ComboItem } from "../../../model";

export default class ArraysService {
  /**
   * Ejecuta un GroupBy sobre un array a partir de un campo como KEY
   * @param xs Array de datos
   * @param key Nombre del Campo a agrupar
   * @returns Un objeto donde cada propiedad es un valor del KEY y como valor el array de elementos agrupados.
   * @example array: [{a:'x',b:2},{a:'x',b:3},{a:'y',b:4}] key: 'a' => return { x: [{a:'x',b:2},{a:'x',b:3}], y: [{a:'y',b:4}] }
   */
  groupBy = <T>(xs : Array<T>, key: string) : any => {
    return xs.reduce((rv:any, x:any) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };
  
  
  distinct = <T>(array: T[]) =>
    array.filter((value, index, self) => self.indexOf(value) === index)

  sum = (array?: (number | undefined)[]) : number | undefined =>
    !!array ? array.reduce((a: (number | undefined), b: number | undefined) => {
      if (b !== undefined && b !== null) return (a ?? 0) + b;
      return a;
    }, undefined) : undefined;

  /**
   * Ayuda a ordenar un array, usable como "array.sort(Common.array.sort(p => p.Nombre, ''))"
   * @param getValue Función para obtener el campo a comparar
   * @param defValue Valor default cuando la función devuelve un undefined|null
   * @returns 
   */
  sort = <T>(getValue: (x:T) => any, defValue?: any) : (a:T, b:T) => number => {
    return (a: T, b: T) => (getValue(a) ?? defValue) > (getValue(b) ?? defValue) ? 1 : -1;
  }

  /**
   * Ayuda a ordenar un array de forma descendente, usable como "array.sort(Common.array.sort(p => p.Nombre, ''))"
   * @param getValue Función para obtener el campo a comparar
   * @param defValue Valor default cuando la función devuelve un undefined|null
   * @returns 
   */
  sortDesc = <T>(getValue: (x:T) => any, defValue?: any) : (a:T, b:T) => number => {
    return (a: T, b: T) => (getValue(a) ?? defValue) > (getValue(b) ?? defValue) ? -1 : 1;
  }

  /**
   * Ayuda a ordenar un array, usable como "array.sort(Common.array.sort(p => p.Nombre, ''))"
   * @param getValue Función para obtener el campo a comparar
   * @param defValue Valor default cuando la función devuelve un undefined|null
   * @returns 
   */
  sortCombo = (t: FxTranslate) : (a:ComboItem & { show?: string }, b:ComboItem & { show?: string }) => number => {
    return (a: ComboItem, b: ComboItem) => 
      (!a.id ? -1 : 
        (!b.id ? 1 :
          (t(a.showKey??'') > t(b.showKey??'') ? 1 : -1)
      ));
  }

  ComboItem = (t: FxTranslate, arr: ComboItem[]) : (ComboItem & { show: string })[] => {
    return arr.map(p => ({ ...p, show: t(p.showKey) }))
      .sort((a,b) => 
        (!a.id ? -1 : 
          (!b.id ? 1 :
            (a.show??'') > (b.show??'') ? 1 : -1)
        ));
  }
  
}